import { useRouter } from 'next/router';
import React from 'react';
import WidgetFollow from 'src/components/widgets/widget-follow';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

function Footer() {
  const router = useRouter();
  return (
    <FooterWrapper>
      <div className='container content'>
        <div className='left'>
          <WidgetFollow
            //! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'follow',
              position: 'on:header'
            }}
          />
        </div>
        <div className='right'>
          <div className='text'>© THE PEOPLE ALL RIGHTS RESERVED.</div>
          <img className='image' src='https://thepeople.my.canva.site/chaliang/images/d510500536f4d8189115474008c35fb5.png' />
        </div>
      </div>
    </FooterWrapper>
  );
}

const FooterWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 10px 0;
  background-size: cover;
  background-position: bottom center;
  background-color: #6b64a0;
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 20px;
    }
    .left {
      width: fit-content;
      #widget-follow {
      }
    }
    .right {
      width: fit-content;
      position: relative;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 50%;
      @media (max-width: 767px) {
        width: 100%;
      }
      @media (max-width: 475px) {
        flex-direction: column;
      }
      .text {
        font-weight: 400;
        color: white;
        font-size: 14px;
        @media (max-width: 767px) {
          font-size: 12px;
        }
      }
      .image {
        width: 40%;
      }
    }
  }
`;
export default Footer;
